'use client';

import { Suspense } from 'react';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { showWalletModal } from '../wallet-modal';

function WalletEntranceContent() {
  const searchParams = useSearchParams();

  useEffect(() => {
    const walletEntrance = searchParams.get('walletEntrance');
    if (walletEntrance) {
      showWalletModal({ entrance: walletEntrance as any });
    }
  }, [searchParams]);

  return null;
}

export function WalletEntrance() {
  return (
    <Suspense fallback={null}>
      <WalletEntranceContent />
    </Suspense>
  );
}